import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import {
  RecipientType,
  recipientTypeLabels,
} from '@src/main/modules/messages/ui/mailbox/components/new-message/types/recipient.types';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  control: Control<NewMessageFormData>;
  styles: Record<string, string>;
}

export const RecipientSelector: FC<Props> = ({ control, styles }) => {
  const { t } = useTranslation();

  const recipientOptions = Object.values(RecipientType).map((type) => ({
    value: type,
    label: t(recipientTypeLabels[type]),
  }));

  return (
    <div className={styles['form-section']}>
      <label>{t('messages.mailbox.recipients')}</label>
      <Controller
        name="recipients"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <select {...field} className={`${styles['form-input']} ${styles['form-recipient']}`}>
            <option value="">{t('messages.mailbox.recipientTypes.select')}</option>
            {recipientOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}
      />
    </div>
  );
};
